import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { ScoreRadio } from '~/@mid_ui-form/score-radio/ScoreRadio'
import { ScoreRadioGroup } from '~/@mid_ui-form/score-radiu-group/ScoreRadioGroup'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step4Schema = z.object({
  investmentDuration: z.object({
    value: z.enum(['shortterm', 'midterm', 'longterm']),
    score: z.number(),
  }),
})
export type Step4Data = z.infer<typeof step4Schema>

export function Step4() {
  const { onStepCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step4Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>
            {unsophisticatedQuestions.investmentDuration.question.label}
          </StepTitle>
          <Controller
            control={control}
            name="investmentDuration"
            render={({ field }) => (
              <ScoreRadioGroup
                value={field.value}
                onValueChange={field.onChange}>
                {Object.entries(
                  unsophisticatedQuestions.investmentDuration.answers
                ).map(([value, answer]) => (
                  <ScoreRadio
                    key={value}
                    score={answer.score}
                    value={value}
                    label={answer.label}
                  />
                ))}
              </ScoreRadioGroup>
            )}
          />
        </>
      )}
    />
  )
}
